import React, { useState, useEffect, useContext } from 'react'

import * as Constantes from '../../utils/constantes'
import GeneralContext from '../../context/GeneralContext'
import * as GeneralActions from '../../store/actions/generalActions'

import styles from './Beneficiarios.module.css'

import Header from '../../components/Header'
import SubMenu from '../../components/SubMenu'
import Footer from '../../components/Footer'
import ListaBeneficiarios from '../../components/ListaBeneficiarios'
import Cesion from '../../components/Cesion'
import Modal from '../../components/Modals/Modal'
import BeneficiarioMultiple from '../../components/BeneficiarioMultiple/BeneficiarioMultiple'
import BeneficiarioDobleAsegurado from '../../components/BeneficiarioDobleAsegurado/BeneficiarioDobleAsegurado'

import * as SolicitudRepository from "../../services/repositories/solicitud-repository";
import * as BeneficiarioRepository from "../../services/repositories/beneficiario-repository";

const Beneficiarios = ({ history }) => {
    const { state: generalState, dispatch: generalDispatch } = useContext(GeneralContext)
    let user = generalState.users.filter(user => user.isAuthenticated)[0]
    let prospecto = user.listaProspectos.filter(prospecto => prospecto.isSelected)[0]
    let cotizacion = prospecto.cotizaciones.filter(cotizacion => cotizacion.isSelected || cotizacion.completado)[0]

    const initialState = {
        estaCargando: true,
        errorCargando: null,
        asegurado: null,
        productos: [],
        tipoCaso: null,
        beneficiarioSeleccionado: null,
        esDistintoAsegurado: null,
        solicitudes: [],
        beneficiariosPrincipales: [],
        beneficiariosContingentes: [],
        beneficiariosUnicos: [],
        beneficiariosApoderado: [],
        mostrarApoderado: false,
        beneficiarioUnico: null,
        indicadorAseguradoCobraBeneficio: null,
        condicionCesionDerechos: null,
        reloadValidacion: false,
        textoError: [],
        porcentajePrincipales: 0,
        porcentajeContingentes: 0,
        campoValidado: {
            //BENEFICIARIO MODAL
            tipoDocumento: true,
            numeroDocumento: true,
            nombres: true,
            apellidoPaterno: true,
            apellidoMaterno: true,
            parentesco: true,
            fechaNacimiento: true,
            sexo: true,
            porcentajeBeneficio: true
        },
        modalInsertar: false,
        modalBorrar: false,
        beneficiarioMultiple: null,
        modalMultiple: false,
        esAseguradoAdicional: false
    }

    const [state, setState] = useState(initialState)
    const [mostrar, setMostrar] = useState(false)

    const generarListasBeneficiarios = (beneficiario, beneficiariosDestinoAux) => {
        if (beneficiariosDestinoAux.length > 0) {
            let beneficiarioExiste = null
            beneficiariosDestinoAux.map(beneficiarioAux => {
                if (beneficiarioAux.numeroDocumento === beneficiario.numeroDocumento &&
                    beneficiarioAux.tipoBeneficiario.codigo === beneficiario.tipoBeneficiario.codigo &&
                    beneficiarioAux.nombres === beneficiario.nombres &&
                    beneficiarioAux.apellidoPaterno === beneficiario.apellidoPaterno &&
                    beneficiarioAux.apellidoMaterno === beneficiario.apellidoMaterno) {
                        beneficiarioExiste = beneficiarioAux
                }
                return beneficiarioAux
            })

            if (beneficiarioExiste !== null) {
                beneficiarioExiste.idBeneficiarioArray[beneficiarioExiste.idBeneficiarioArray.length] = beneficiario.idBeneficiario
                beneficiarioExiste.idSolicitudArray[beneficiarioExiste.idSolicitudArray.length] = beneficiario.idSolicitud
            } else {
                beneficiario.idBeneficiarioArray = [beneficiario.idBeneficiario]
                beneficiario.idSolicitudArray = [beneficiario.idSolicitud]
                beneficiariosDestinoAux[beneficiariosDestinoAux.length] = beneficiario
            }
        } else {
            beneficiario.idBeneficiarioArray = [beneficiario.idBeneficiario]
            beneficiario.idSolicitudArray = [beneficiario.idSolicitud]
            beneficiariosDestinoAux[0] = beneficiario
        }

        return beneficiariosDestinoAux
    }

    const obtenerApoderado = (beneficiario, beneficiariosDestinoAux) => {
        if (beneficiario !== null) {
            setState((state) => {
                return {
                    ...state,
                    mostrarApoderado: true,
                    beneficiarioUnico: beneficiario
                }
            })
            if (beneficiario.tutor !== undefined && beneficiario.tutor !== null) {
                beneficiariosDestinoAux.push(beneficiario.tutor)
            }
        }
    }

    const obtenerBeneficiarios = async () => {
        const response = await BeneficiarioRepository.obtenerBeneficiarios(cotizacion.idSolicitudMultiple)
        if (response.error === null) {
            generalDispatch(GeneralActions.setBeneficiarios(response.beneficiarios))
            let beneficiarios = response.beneficiarios
            let beneficiariosPrincipalesAux = []
            let beneficiariosContingentesAux = []
            let beneficiariosUnicosAux = []
            let beneficiariosApoderadoAux = []

            setState((state) => {
                return {
                    ...state,
                    mostrarApoderado: false
                }
            })

            beneficiarios.map(beneficiario => {
                switch (beneficiario.tipoBeneficiario.codigo) {
                    case Constantes.COD_TIPO_BENEFICIARIO_PRINCIPAL: {
                        beneficiariosPrincipalesAux = generarListasBeneficiarios(beneficiario, beneficiariosPrincipalesAux)
                        break
                    }
                    case Constantes.COD_TIPO_BENEFICIARIO_CONTINGENTE: {
                        beneficiariosContingentesAux = generarListasBeneficiarios(beneficiario, beneficiariosContingentesAux)
                        break
                    }
                    case Constantes.COD_TIPO_BENEFICIARIO_UNICO: {
                        beneficiariosUnicosAux = generarListasBeneficiarios(beneficiario, beneficiariosUnicosAux)
                        obtenerApoderado(beneficiario, beneficiariosApoderadoAux)
                        break
                    }
                    default: {
                        break
                    }
                }
                return beneficiario
            })

            setState((state) => {
                return {
                    ...state,
                    estaCargando: false,
                    errorCargando: null,
                    beneficiariosPrincipales: beneficiariosPrincipalesAux,
                    beneficiariosContingentes: beneficiariosContingentesAux,
                    beneficiariosUnicos: beneficiariosUnicosAux,
                    beneficiariosApoderado: beneficiariosApoderadoAux
                }
            })
        } else {
            generalDispatch(GeneralActions.updateError(response.error, '¡Alerta!', true))
        }
    }

    const cargarDatosIniciales = async () => {
        const obtenerDetalleCotizacion = async () => {
            let tieneFU = false
            let tieneDiferenteFU = false
            let caso = null
            cotizacion.productos.map(productoAux => {
                if (productoAux.codigoTipoProducto === Constantes.COD_TIPO_PRODUCTO_FONDO_UNIVERSITARIO) {
                    tieneFU = true
                } else if (productoAux.codigoTipoProducto !== Constantes.COD_TIPO_PRODUCTO_FONDO_UNIVERSITARIO) {
                    tieneDiferenteFU = true
                }
                return productoAux
            })

            if (tieneFU && !tieneDiferenteFU) {
                caso = Constantes.TIPO_CASO_1
            } else if (!tieneFU && tieneDiferenteFU) {
                caso = Constantes.TIPO_CASO_2
            } else if (tieneFU && tieneDiferenteFU) {
                caso = Constantes.TIPO_CASO_3
            } else {
                caso = null
            }

            setState((state) => {
                return {
                    ...state,
                    errorCargando: null,
                    productos: cotizacion.productos,
                    tipoCaso: caso,
                    esDistintoAsegurado: cotizacion.esDistintoAsegurado
                }
            })

            await obtenerSolicitudes()
        }

        const obtenerSolicitudes = async () => {
            const response = await SolicitudRepository.obtenerSolicitudes(cotizacion.idSolicitudMultiple)
            if (response.error === null) {
                let listaSolicitudes = response.solicitudes
                listaSolicitudes.productos.map(productoSolc => {
                    cotizacion.productos.map(producto => {
                        if (producto.codigoProducto === productoSolc.codigoProducto) {
                            productoSolc.codigoTipoProducto = producto.codigoTipoProducto
                        }
                        return producto
                    })
                    return productoSolc
                })

                const solicitudes = response.solicitudes.solicitudes;
                const valores = solicitudes.map(s => s.beneficiarioMultiple);
                const beneficiarioMultipleResult = valores.includes(true) ? true : 
                                                valores.includes(false) ? false : 
                                                null;
                                                
                setState((state) => {
                    return {
                        ...state,
                        errorCargando: null,
                        solicitudes: listaSolicitudes,
                        condicionCesionDerechos: solicitudes.condicionCesionDerechos,
                        indicadorAseguradoCobraBeneficio: solicitudes.indicadorAseguradoCobraBeneficio,
                        beneficiarioMultiple: beneficiarioMultipleResult,
                        asegurado: response.solicitudes.asegurado
                    }
                })

                //DISPATCH
                generalDispatch(GeneralActions.updateAseguradoProspecto(response.solicitudes.preguntas, response.solicitudes.subPreguntas))
                generalDispatch(GeneralActions.updateAseguradoAdicionalProspecto(response.solicitudes.preguntas, response.solicitudes.subPreguntas))
                await obtenerBeneficiarios()
            } else {
                generalDispatch(GeneralActions.updateError(response.error, '¡Alerta!', true))
            }
        }

        generalDispatch(GeneralActions.updateEstadoCargando(true))
        await obtenerDetalleCotizacion()
        generalDispatch(GeneralActions.updateEstadoCargando(false))
        await flagEsAseguradoAdicional()
    }

    const flagEsAseguradoAdicional = async () => {
        let esAseguradoAdicional = false
        cotizacion.solicitudes.map(solicitud => {
            esAseguradoAdicional = solicitud.indicadorAseguradoAdicional
        })
        setState((state) => {
            return {
                ...state,
                esAseguradoAdicional: esAseguradoAdicional
            }
        })
    }

    useEffect(() => {
        cargarDatosIniciales()
    }, [])

    const validarFormulario = async () => {
        let validado = true
        const mostrarError = (cabeceraError, mensajeError) => {
            validado = false
            setState((state) => {
                return {
                    ...state,
                    textoError: [cabeceraError, mensajeError]

                }
            })
            setMostrar(true)
        }

        const invocarPutSolicitudes = async () => {
            let salida = true;
            
            try {
                const invocarServicio = async (solicitud) => {
                    const response = await SolicitudRepository.actualizarSolicitud(cotizacion.idSolicitudMultiple, solicitud.marcaLpdp, solicitud.marcaAdicionalLpdp, solicitud.solicitud)
                    if (response.error === null) {
                        return true
                    } else {
                        generalDispatch(GeneralActions.updateError(response.error, '¡!Alerta'))
                        return false
                    }
                }

                for (const producto of state.solicitudes.productos) {
                    let solicitudAux = {
                        marcaLpdp: cotizacion.lpdp,
                        marcaAdicionalLpdp: cotizacion.lpdpAdicional,
                        solicitud: {
                            idSolicitud: producto.idSolicitud
                        }
                    }
                    if (state.condicionCesionDerechos !== null) {
                        solicitudAux.solicitud.condicionCesionDerechos = state.condicionCesionDerechos
                    }
                    if (state.tipoCaso === Constantes.TIPO_CASO_1 || state.tipoCaso === Constantes.TIPO_CASO_3) {
                        solicitudAux.solicitud.beneficiarioMultiple = state.beneficiarioMultiple
                        solicitudAux.solicitud.indicadorAseguradoCobraBeneficio = true
                    } else {
                        solicitudAux.solicitud.indicadorAseguradoCobraBeneficio = state.indicadorAseguradoCobraBeneficio
                    }

                    salida = salida && await invocarServicio(solicitudAux)
                }

                return salida
            } catch (error) {
                console.error(error)
                return !salida
            }
        }

        let preguntaCesion = state.condicionCesionDerechos

        /*Nueva validacion con beneficiarios multiples */
        if (state.tipoCaso === Constantes.TIPO_CASO_1 && !state.esAseguradoAdicional ) {
            if (state.beneficiarioMultiple !== null) {
                if (state.beneficiarioMultiple) {
                    //Validar Beneficiario Principales
                    if (state.porcentajePrincipales < 100) {
                        mostrarError('Beneficiarios Principales', 'Debes asignar o redistribuir el 100% de tu cobertura para continuar.')
                    } else {
                        //Validar Beneficiario Contingente
                        if (state.beneficiariosContingentes.length > 0 && state.porcentajeContingentes < 100) {
                            mostrarError('Beneficiarios Contingentes', 'Debes asignar o redistribuir el 100% de tu cobertura para continuar.')
                        } else {
                            //Cesion
                            if (cotizacion.esDistintoAsegurado && preguntaCesion === null) {
                                mostrarError('¡Alerta!', 'Debes selecionar una opción de Cesión de Derechos para continuar.')
                            }
                        }
                    }
                } else {
                    //Validar Beneficiario Unico
                    if (state.beneficiariosUnicos.length < 1) {
                        mostrarError('Beneficiario', 'Debes ingresar un Beneficiario Unico para continuar.')
                    } else {
                        //Validar Apoderado
                        if (state.beneficiariosApoderado.length < 1) {
                            mostrarError('Beneficiario', 'Debes ingresar un Apoderado para continuar.')
                        } else {
                            //Cesion
                            if (cotizacion.esDistintoAsegurado && preguntaCesion === null) {
                                mostrarError('¡Alerta!', 'Debes selecionar una opción de Cesión de Derechos para continuar.')
                            }
                        }
                    }
                }
            } else {
                mostrarError('¡Alerta!', 'Debes selecionar un tipo de beneficiario')
            }
        } else if (state.tipoCaso === Constantes.TIPO_CASO_2 && !state.esAseguradoAdicional) {
            //Validar Beneficiario Principales
            if (state.porcentajePrincipales < 100) {
                mostrarError('Beneficiarios Principales', 'Debes asignar o redistribuir el 100% de tu cobertura para continuar.')
            } else {
                //Validar Beneficiario Contingente
                if (state.beneficiariosContingentes.length > 0 && state.porcentajeContingentes < 100) {
                    mostrarError('Beneficiarios Contingentes', 'Debes asignar o redistribuir el 100% de tu cobertura para continuar.')
                } else {
                    //Cesion
                    if (cotizacion.esDistintoAsegurado && preguntaCesion === null) {
                        mostrarError('¡Alerta!', 'Debes selecionar una opción de Cesión de Derechos para continuar.')
                    }
                }
            }
        } else if (state.tipoCaso === Constantes.TIPO_CASO_3 && !state.esAseguradoAdicional) {
            if (state.beneficiarioMultiple !== null) {
                if (state.beneficiarioMultiple) {
                    //Validar Beneficiario Principales
                    if (state.porcentajePrincipales < 100) {
                        mostrarError('Beneficiarios Principales', 'Debes asignar o redistribuir el 100% de tu cobertura para continuar.')
                    } else {
                        //Validar Beneficiario Contingente
                        if (state.beneficiariosContingentes.length > 0 && state.porcentajeContingentes < 100) {
                            mostrarError('Beneficiarios Contingentes', 'Debes asignar o redistribuir el 100% de tu cobertura para continuar.')
                        } else {
                            //Cesion
                            if (cotizacion.esDistintoAsegurado && preguntaCesion === null) {
                                mostrarError('¡Alerta!', 'Debes selecionar una opción de Cesión de Derechos para continuar.')
                            }
                        }
                    }
                } else {
                    //Validar Beneficiario Principales
                    if (state.porcentajePrincipales < 100) {
                        mostrarError('Beneficiarios Principales', 'Debes asignar o redistribuir el 100% de tu cobertura para continuar.')
                    } else {
                        //Validar Beneficiario Contingente
                        if (state.beneficiariosContingentes.length > 0 && state.porcentajeContingentes < 100) {
                            mostrarError('Beneficiarios Contingentes', 'Debes asignar o redistribuir el 100% de tu cobertura para continuar.')
                        } else {
                            //Validar Beneficiario Unico
                            if (state.beneficiariosUnicos.length < 1) {
                                mostrarError('Beneficiario', 'Debes ingresar un Beneficiario Unico para continuar.')
                            } else {
                                //Validar Apoderado
                                if (state.beneficiariosApoderado.length < 1) {
                                    mostrarError('Beneficiario', 'Debes ingresar un Apoderado para continuar.')
                                } else {
                                    //Cesion
                                    if (cotizacion.esDistintoAsegurado && preguntaCesion === null) {
                                        mostrarError('¡Alerta!', 'Debes selecionar una opción de Cesión de Derechos para continuar.')
                                    }
                                }
                            }
                        }
                    }
                }
            } else {
                mostrarError('¡Alerta!', 'Debes selecionar un tipo de beneficiario')
            }
        }

        if (validado) {
            let salida = await invocarPutSolicitudes()
            return salida
        } else {
            return false
        }
    }

    const [mover, setMover] = useState(false)
    const mueveContenido = (valor) => {
        setMover(valor)
    }

    return (
        <React.Fragment>
            <Header history={history} />
            <SubMenu
                history={history}
                modal={mostrar || state.estaCargando || state.modalInsertar || state.modalBorrar || state.modalMultiple}
                desplaza={mueveContenido}
                validarPantalla={validarFormulario}
            />
            <section className={styles['areadatosusuario']}
                style={mover ? { width: '93%', paddingLeft: '6.5%', height: '100vh' } : {}}
            >
                {/*DERECHO CESION*/}
                {cotizacion.esDistintoAsegurado
                    ? <Cesion
                        state={state}
                        setState={setState} />
                    : null
                }

                { 
                        state.esAseguradoAdicional ?
                            <div>
                                <div>
                                    <BeneficiarioDobleAsegurado />
                                </div>
                            </div>

                        : 
                            <div>
                                { 
                                    state.tipoCaso === Constantes.TIPO_CASO_1 ?
                                        <div>
                                            <BeneficiarioMultiple
                                                state={state}
                                                setState={setState}
                                            />
                                            {state.beneficiarioMultiple === null ? null
                                                : state.beneficiarioMultiple ?
                                                    <div>
                                                        <ListaBeneficiarios
                                                            beneficiarios={state.beneficiariosPrincipales}
                                                            codTipoBeneficiario={Constantes.COD_TIPO_BENEFICIARIO_PRINCIPAL}
                                                            state={state}
                                                            setState={setState}
                                                            recargarLista={obtenerBeneficiarios}
                                                        />
                                                        <ListaBeneficiarios
                                                            beneficiarios={state.beneficiariosContingentes}
                                                            codTipoBeneficiario={Constantes.COD_TIPO_BENEFICIARIO_CONTINGENTE}
                                                            state={state}
                                                            setState={setState}
                                                            recargarLista={obtenerBeneficiarios}
                                                        />
                                                    </div>

                                                    : !state.beneficiarioMultiple ?
                                                        <div>
                                                            <ListaBeneficiarios
                                                                beneficiarios={state.beneficiariosUnicos}
                                                                codTipoBeneficiario={Constantes.COD_TIPO_BENEFICIARIO_UNICO}
                                                                state={state}
                                                                setState={setState}
                                                                recargarLista={obtenerBeneficiarios}
                                                            />
                                                            <ListaBeneficiarios
                                                                beneficiarios={state.beneficiariosApoderado}
                                                                codTipoBeneficiario={Constantes.COD_TIPO_BENEFICIARIO_APODERADO}
                                                                state={state}
                                                                setState={setState}
                                                                recargarLista={obtenerBeneficiarios}
                                                            />
                                                        </div>
                                                        : null
                                            }
                                        </div>
                                    : 
                                        state.tipoCaso === Constantes.TIPO_CASO_2 ?
                                        <div>
                                            <ListaBeneficiarios
                                                beneficiarios={state.beneficiariosPrincipales}
                                                codTipoBeneficiario={Constantes.COD_TIPO_BENEFICIARIO_PRINCIPAL}
                                                state={state}
                                                setState={setState}
                                                recargarLista={obtenerBeneficiarios}
                                            />
                                            <ListaBeneficiarios
                                                beneficiarios={state.beneficiariosContingentes}
                                                codTipoBeneficiario={Constantes.COD_TIPO_BENEFICIARIO_CONTINGENTE}
                                                state={state}
                                                setState={setState}
                                                recargarLista={obtenerBeneficiarios}
                                            />
                                        </div>
                                        : state.tipoCaso === Constantes.TIPO_CASO_3 ?
                                            <div>
                                                <BeneficiarioMultiple
                                                    state={state}
                                                    setState={setState}
                                                />
                                                {state.beneficiarioMultiple === null ? null
                                                    : state.beneficiarioMultiple ?
                                                        <div>
                                                            <ListaBeneficiarios
                                                                beneficiarios={state.beneficiariosPrincipales}
                                                                codTipoBeneficiario={Constantes.COD_TIPO_BENEFICIARIO_PRINCIPAL}
                                                                state={state}
                                                                setState={setState}
                                                                recargarLista={obtenerBeneficiarios}
                                                            />
                                                            <ListaBeneficiarios
                                                                beneficiarios={state.beneficiariosContingentes}
                                                                codTipoBeneficiario={Constantes.COD_TIPO_BENEFICIARIO_CONTINGENTE}
                                                                state={state}
                                                                setState={setState}
                                                                recargarLista={obtenerBeneficiarios}
                                                            />
                                                        </div>

                                                        : !state.beneficiarioMultiple ?
                                                            <div>
                                                                {state.productos.map((producto, index) => {
                                                                    return (
                                                                        producto.codigoTipoProducto === 2 ?
                                                                            <div key={index}>
                                                                                <h2 className={styles.nombreProducto}>{producto.descripcion}</h2>
                                                                                <ListaBeneficiarios
                                                                                    beneficiarios={state.beneficiariosUnicos}
                                                                                    codTipoBeneficiario={Constantes.COD_TIPO_BENEFICIARIO_UNICO}
                                                                                    state={state}
                                                                                    setState={setState}
                                                                                    recargarLista={obtenerBeneficiarios}
                                                                                />
                                                                                <ListaBeneficiarios
                                                                                    beneficiarios={state.beneficiariosApoderado}
                                                                                    codTipoBeneficiario={Constantes.COD_TIPO_BENEFICIARIO_APODERADO}
                                                                                    state={state}
                                                                                    setState={setState}
                                                                                    recargarLista={obtenerBeneficiarios}
                                                                                />
                                                                            </div>
                                                                            :
                                                                            <div key={index}>
                                                                                <h2 key={index} className={styles.nombreProducto}>{producto.descripcion}</h2>
                                                                                <ListaBeneficiarios
                                                                                    beneficiarios={state.beneficiariosPrincipales}
                                                                                    codTipoBeneficiario={Constantes.COD_TIPO_BENEFICIARIO_PRINCIPAL}
                                                                                    state={state}
                                                                                    setState={setState}
                                                                                    recargarLista={obtenerBeneficiarios}
                                                                                />
                                                                                <ListaBeneficiarios
                                                                                    beneficiarios={state.beneficiariosContingentes}
                                                                                    codTipoBeneficiario={Constantes.COD_TIPO_BENEFICIARIO_CONTINGENTE}
                                                                                    state={state}
                                                                                    setState={setState}
                                                                                    recargarLista={obtenerBeneficiarios}
                                                                                />
                                                                            </div>
                                                                    )
                                                                })}
                                                            </div>
                                                            : null
                                                }
                                            </div>
                                            : null
                                }
                            </div>

                }


                

                {/*BENEFICIARIOS PRINCIPALES*/}
                {/*state.tipoCaso === Constantes.TIPO_CASO_2 || state.tipoCaso === Constantes.TIPO_CASO_3
                    ? <ListaBeneficiarios
                        beneficiarios={state.beneficiariosPrincipales}
                        codTipoBeneficiario={Constantes.COD_TIPO_BENEFICIARIO_PRINCIPAL}
                        state={state}
                        setState={setState}
                        recargarLista={obtenerBeneficiarios}
                    />
                    : null
            */}
                {/*BENEFICIARIOS CONTINGENTES*/}
                {/*state.tipoCaso === Constantes.TIPO_CASO_2 || state.tipoCaso === Constantes.TIPO_CASO_3
                    ? <ListaBeneficiarios
                        beneficiarios={state.beneficiariosContingentes}
                        codTipoBeneficiario={Constantes.COD_TIPO_BENEFICIARIO_CONTINGENTE}
                        state={state}
                        setState={setState}
                        recargarLista={obtenerBeneficiarios}
                    />
                    : null
        */}
                {/*BENEFICIARIO UNICO*/}
                {/*state.tipoCaso === Constantes.TIPO_CASO_1 || state.tipoCaso === Constantes.TIPO_CASO_3
                    ? <ListaBeneficiarios
                        beneficiarios={state.beneficiariosUnicos}
                        codTipoBeneficiario={Constantes.COD_TIPO_BENEFICIARIO_UNICO}
                        state={state}
                        setState={setState}
                        recargarLista={obtenerBeneficiarios}
                    />
                    : null
    */}
                {/*PREGUNTA*/}
                {/*state.tipoCaso === Constantes.TIPO_CASO_1 || state.tipoCaso === Constantes.TIPO_CASO_3
                    ? <PreguntaRadio
                        textosPregunta={Constantes.MENSAJE_PREGUNTA_BENEFICIARIOS}
                        state={state}
                        setState={setState}
                    />
                    : null
*/}
                {/*BENEFICIARIOS APODERADO*/}
                {/*(state.tipoCaso === Constantes.TIPO_CASO_1 || state.tipoCaso === Constantes.TIPO_CASO_3)
                    ? <ListaBeneficiarios
                        beneficiarios={state.beneficiariosApoderado}
                        codTipoBeneficiario={Constantes.COD_TIPO_BENEFICIARIO_APODERADO}
                        state={state}
                        setState={setState}
                        recargarLista={obtenerBeneficiarios}
                    />
                    : null
*/}

                <Modal mostrarModal={mostrar} setModal={setMostrar} textos={state.textoError} />
                <Footer history={history} validarPantalla={validarFormulario} />
            </section>
        </React.Fragment>
    )
}

export default Beneficiarios